import { useCallback, useMemo, useState } from 'react';

import { DOCUMENTS } from './constants';

export const useDocumentSelection = (documents = DOCUMENTS) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const allIds = useMemo(() => documents.map((document) => document.id), [documents]);

  const hasSelection = selectedIds.length > 0;
  const areAllSelected = hasSelection && selectedIds.length === allIds.length;

  const toggleDocument = (id) =>
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]
    );

  const setDocumentSelected = useCallback(
    (id, isSelected) =>
      setSelectedIds((prev) => {
        if (prev.includes(id) === isSelected) return prev;
        return isSelected ? [...prev, id] : prev.filter((selectedId) => selectedId !== id);
      }),
    []
  );

  const toggleAll = () => setSelectedIds(areAllSelected ? [] : allIds);

  const isSelected = (id) => selectedIds.includes(id);

  return {
    selectedIds,
    hasSelection,
    areAllSelected,
    isSelected,
    toggleDocument,
    toggleAll,
    setDocumentSelected
  };
};
